import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

// NOTE: Placeholder testimonials — swap with the real client quotes/names/photos the user provides.
const TESTIMONIALS = [
  {
    name: "Ananya Sharma",
    role: "Software Engineer, hired at a product company",
    quote:
      "The AI builder turned my messy notes into sharp, quantified bullet points. I started getting interview calls within a week of updating my resume.",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    name: "Rahul Verma",
    role: "Banking & Finance Professional",
    quote:
      "Booking a call with an industry expert was the best decision. He reviewed my resume line by line and helped me position myself for senior roles.",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
  {
    name: "Priya Nair",
    role: "Marketing Manager",
    quote:
      "I used the 'Improve Resume' feature and the watermarked preview convinced me instantly. Clean, ATS-ready, and worth every rupee.",
    rating: 5,
    photo: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?crop=entropy&cs=srgb&fm=jpg&q=85&w=200",
  },
];

export const Testimonials = () => {
  return (
    <section className="max-w-7xl mx-auto px-5 py-24" data-testid="testimonials-section">
      <div className="text-center max-w-2xl mx-auto mb-14">
        <span className="text-xs font-semibold uppercase tracking-widest text-primary">Loved by job seekers</span>
        <h2 className="font-heading font-bold text-3xl sm:text-4xl tracking-tight mt-2">
          Real results from real people
        </h2>
        <p className="mt-3 text-muted-foreground">
          Thousands trust ResumePro24 to build resumes, consult experts, and land interviews.
        </p>
      </div>
      <div className="grid md:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: i * 0.1 }}
            className="relative rounded-3xl border border-border bg-card p-8 hover:shadow-xl transition-shadow"
            data-testid={`testimonial-card-${i}`}
          >
            <Quote className="h-8 w-8 text-primary/20 absolute top-6 right-6" />
            <div className="flex items-center gap-1 mb-4">
              {Array.from({ length: t.rating }).map((_, s) => (
                <Star key={s} className="h-4 w-4 text-accent fill-accent" />
              ))}
            </div>
            <p className="text-foreground/90 leading-relaxed">"{t.quote}"</p>
            <div className="mt-6 flex items-center gap-3">
              <img
                src={t.photo}
                alt={t.name}
                className="h-11 w-11 rounded-full object-cover border border-border"
              />
              <div>
                <div className="font-heading font-semibold text-sm">{t.name}</div>
                <div className="text-xs text-muted-foreground">{t.role}</div>
              </div>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
